<groupui-grid-row>
  <groupui-grid-col l="6" m="6" s="6" class="fieldName">{{fieldName | placeholder }}</groupui-grid-col>
  <groupui-grid-col l="6" m="6" s="6" class="value">{{ value | placeholder }} {{ unit }} {{ displaySuffix }}</groupui-grid-col>
</groupui-grid-row>
